export default __webpack_public_path__ + "public/assets/application/img/prompts/deals.1358a356040f965edce65e9ba350e4f8.svg";